export const tipoProdutoEnum = {
  PRODUTO: 'PRODUTO',
  CONSULTORIA: 'CONSULTORIA',
  SAAS_PRODUTO: 'SAAS_PRODUTO',
  EVENTO: 'EVENTO',
  CURSO: 'CURSO',
  SAAS: 'SAAS'
};
